"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "16", height: "15", viewBox: "0 0 16 15", className: "Icon link-fail", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement("path", { d: "M1.284 15c-.459 0-.883-.258-1.112-.678a1.427 1.427 0 0 1 0-1.357L6.887.678C7.117.258 7.541 0 8 0c.46 0 .883.258 1.112.678l6.716 12.287c.23.42.23.936 0 1.357-.23.42-.654.678-1.112.678H1.284z", id: "a-link-fail" })
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { stroke: "#F6A623", d: "M1.284 15c-.459 0-.883-.258-1.112-.678a1.427 1.427 0 0 1 0-1.357L6.887.678C7.117.258 7.541 0 8 0c.46 0 .883.258 1.112.678l6.716 12.287c.23.42.23.936 0 1.357-.23.42-.654.678-1.112.678H1.284z" }),
            _react2.default.createElement(
                "g",
                { fill: "#F6A623" },
                _react2.default.createElement("path", { d: "M7.068 6.712L7 5.5h2l-.068 1.212L8.65 9.5H7.35zM8 12.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" })
            )
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/link-fail.js
// module id = 1810
// module chunks = 0